<template>
  <div class="pro-item" v-if="safeItem" @click="$router.push(
        {
          name: 'product',
          query: {
            id: safeItem.id
          }
        },
        () => {}
      )">
    <img v-lazy="safeItem.carousel_list[0]" :alt="safeItem.name" class="pro-img" />
    <div class="item-content">
      <p class="no">
        No. : <span>{{ safeItem.id }}</span>
      </p>
      <h3 class="van-ellipsis">{{ safeItem.name }}</h3>
      <p class="van-multi-ellipsis--l2" v-html="safeItem.bewrite"></p>
      <p class="price">
        ￥<span>{{ safeItem.starting_price }}</span>
      </p>
    </div>
    <div class="pro-state" v-if="safeItem.status == 2 && safeIsShow">
      {{ safeItem.status_text }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListProductItemView',
  props: ['item','isShow'],
  computed: {
    safeItem () {
      return this.item || null
    },
    safeIsShow(){
      return this.isShow || false
    }
  }
}
</script>
<style lang="scss" scoped>
.pro-item {
  background: white;
  border-radius: 10px;
  box-shadow: 8px 8px 16px rgba(0, 0, 0, 0.3);
  overflow: hidden;
  transition: all 0.3s ease;
  position: relative;
  img.pro-img {
    width: 100%;
    height: 200px;
    object-fit: cover;
    display: block;
  }
  .item-content {
    padding: 10px;
    p.no {
      color: #000;
      font-size: 12px;
      font-weight: 600;
      span {
        font-size: 15px;
      }
    }
    p.price {
      color: #000;
      font-size: 13px;
      span {
        font-size: 16px;
        font-weight: 550;
      }
    }

    h3 {
      font-size: 18px;
      margin-bottom: 8px;
      color: #000;
    }

    p {
      color: #646566;
      font-size: 14px;
      line-height: 1.6;
    }
  }
  .pro-state{
    position: absolute;
    background: rgba(0, 0, 0, 0.6);
    color: #fff;
    width: 100%;
    left: 0;
    top: 160px;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 18px;
    font-weight: 600;
  }
}
</style>
